<rms-base-layout>
  <rms-progress-bar />
  <mat-sidenav-container class="rms-layout-sidenav-container">
    <mat-sidenav
      (closedStart)="onSidenavClosed()"
      [disableClose]="!!(sidenavDisableClose$ | async)"
      [fixedInViewport]="!!(sidenavFixedInViewport$ | async)"
      [mode]="(sidenavMode$ | async) ?? 'side'"
      [opened]="!!(sidenavOpen$ | async)">
      <rms-sidenav [collapsed]="!!(sidenavCollapsed$ | async)" />
    </mat-sidenav>
    <mat-sidenav-content class="rms-layout-sidenav-content">
      @if (sidenavFixedInViewport$ | async) {
        <rms-toolbar class="rms-toolbar" />
      }
      <main class="rms-layout-content">
        <!-- Every child route renders inside the bordered card. A page that needs a different shell
             should render its own rms-page-layout instead of relying on this one. -->
        <rms-page-layout mode="card-romulus">
          <div rmsPageLayoutContent>
            <router-outlet />
          </div>
        </rms-page-layout>
      </main>
      @if (footerVisible) {
        <rms-footer class="rms-footer" />
      }
    </mat-sidenav-content>
  </mat-sidenav-container>
</rms-base-layout>
